import { render } from "./createRoom.vue?vue&type=template&id=4d7756c9"
import script from "./createRoom.vue?vue&type=script&lang=js"
export * from "./createRoom.vue?vue&type=script&lang=js"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__